import { SearchParkablesQueryVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  queryVariables: SearchParkablesQueryVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class SearchParkablesRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { queryVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PARKABLE_TRANSACTIONS,
      type: `SEARCH_PARKABLES.REQUEST`,
      data: {
        queryVariables,
      },
    });
  }
}

export { SearchParkablesRequest };
